// main js - Add logic after load all modules

/* Dropdown */
/**
 * Add Click Event Listener in Close button to close the current dropdown
 * @param {HTMLElement} closeButtonElement - Close button javaScript element selector
 */
function hideDropdown(closeButtonElement) {
  if (!closeButtonElement) return false;

  let dropdownWrapElement = closeButtonElement.closest(".dropdown");
  if (!dropdownWrapElement) return false;

  let toggleTrigger = dropdownWrapElement.querySelector(
    '[data-bs-toggle="dropdown"]'
  );
  if (!toggleTrigger) return false;

  closeButtonElement.addEventListener("click", ({ target }) => {
    let trigger = target
      .closest(".dropdown")
      .querySelector('[data-bs-toggle="dropdown"]');

    trigger.click();

    setTimeout(() => trigger.focus(), 100);
  });
}

(function () {
  const dropdown = document.querySelectorAll('[data-bs-toggle="dropdown"]');

  dropdown.forEach((item) => {
    item.addEventListener("show.bs.dropdown", ({ target }) => {
      target.classList.add("active");
    });

    item.addEventListener("hide.bs.dropdown", ({ target }) => {
      target.classList.remove("active");
    });
  });

  const dropdownCloseTriggers = document.querySelectorAll(".js-hide-dropdown");
  dropdownCloseTriggers.forEach((item) => {
    hideDropdown(item);
  });
})();
